<template>
<div class="row justify-content-md-center">

	<div class="col-12 col-xl-8">

		<b-form @submit.prevent="submitForm"
		        class="mb-3">
			<b-btn variant="outline-secondary"
			       v-b-tooltip.hover
			       title="Terug"
			       class="pull-right"
			       exact
			       :to="{ name: 'auctionList' }">
				<i class="fa fa-fw fa-reply"></i>
			</b-btn>
			<h1 class="display-4"
			    v-if="mode == 'edit'">Veiling aanpassen</h1>
			<h1 class="display-4"
			    v-if="mode == 'add'">Veiling toevoegen</h1>
			<h2 v-if="!isFetching">{{ form.title }}</h2>

			<partial-loader :loading="isFetching"></partial-loader>

			<div v-if="!isFetching">

				<b-alert v-if="formError"
				         show
				         variant="warning">
					<span v-for="errors in formError.errors">
							<span v-for="error in errors">{{ error }}<br /></span>
					</span>
				</b-alert>

				<div class="row">
					<div class="col">
						<b-form-group label="Titel:">
							<b-form-input type="text"
							              v-model="form.title">
							</b-form-input>
						</b-form-group>

						<b-form-group label="Afkorting:">
							<b-form-input type="text"
							              v-model="form.abbreviation">
							</b-form-input>
						</b-form-group>

						<b-form-group label="Begin datum:">
							<b-form-input type="date"
							              v-model="form.start">
							</b-form-input>

						</b-form-group>

						<b-form-group label="Eind datum:">
							<b-form-input type="date"
							              v-model="form.end">
							</b-form-input>
						</b-form-group>
					</div>

					<div class="col-8">
						<b-form-group label="Beschrijving:">
							<b-form-textarea v-model="form.description"
							                 :rows="10">
							</b-form-textarea>
						</b-form-group>
					</div>

				</div>

				<hr />

				<div class="row">

					<div class="col-md-3">
						<b-form-group label="Inbrenger commissie percentage:">
							<b-input-group>
								<b-input-group-prepend is-text>
									<i class="fas fa-percentage fa-fw"></i>
								</b-input-group-prepend>

								<b-form-input type="number"
								              v-model="form.seller_commission_percentage"></b-form-input>
							</b-input-group>
						</b-form-group>

						<b-form-group type="number"
						              label="Cliënt commissie percentage:">
							<b-input-group>
								<b-input-group-prepend is-text>
									<i class="fas fa-percentage fa-fw"></i>
								</b-input-group-prepend>

								<b-form-input type="number"
								              v-model="form.buyer_commission_percentage"></b-form-input>
							</b-input-group>
						</b-form-group>
					</div>

					<div class="col-md-3">
						<b-form-group label="Tafelgeld per kavel:">
							<b-input-group>
								<b-input-group-prepend is-text>
									<i class="fas fa-euro-sign fa-fw"></i>
								</b-input-group-prepend>

								<b-form-input type="number"
								              step="any"
								              v-model="form.table_money"></b-form-input>
							</b-input-group>
						</b-form-group>

						<b-form-group type="number"
						              label="Fotogeld per kavel:">
							<b-input-group>
								<b-input-group-prepend is-text>
									<i class="fas fa-euro-sign fa-fw"></i>
								</b-input-group-prepend>
								
								<b-form-input type="number"
								              step="any"
								              v-model="form.photo_cost"></b-form-input>
							</b-input-group>
						</b-form-group>
					</div>
				</div>

				<hr />

				<div class="row">

					<div class="col-md-6">
						<b-form-group :label="$t('auction.billRemarkText')">
							<b-form-textarea v-model="form.bill_remark_text"
							                 :rows="3">
							</b-form-textarea>
						</b-form-group>
					</div>

					<div class="col-md-6">
						<b-form-group :label="$t('auction.billFooterText')">
							<b-form-textarea v-model="form.bill_footer_text"
							                 :rows="3">
							</b-form-textarea>
						</b-form-group>
					</div>

				</div>

				<div class="row">

					<div class="col-md-6">
						<b-form-group :label="$t('auction.overviewRemarkText')">
							<b-form-textarea v-model="form.overview_remark_text"
							                 :rows="3">
							</b-form-textarea>
						</b-form-group>
					</div>

					<div class="col-md-6">
						<b-form-group :label="$t('auction.overviewFooterText')">
							<b-form-textarea v-model="form.overview_footer_text"
							                 :rows="3">
							</b-form-textarea>
						</b-form-group>
					</div>

				</div>

				<div class="row">

					<div class="col-md-6">
						<b-form-group :label="$t('auction.sellerInvoiceEmail')">
							<b-form-textarea v-model="form.seller_invoice_email_text"
							                 :rows="3">
							</b-form-textarea>
						</b-form-group>
					</div>

					<div class="col-md-6">
						<b-form-group :label="$t('auction.buyerInvoiceEmail')">
							<b-form-textarea v-model="form.buyer_invoice_email_text"
							                 :rows="3">
							</b-form-textarea>
						</b-form-group>
					</div>

				</div>

				<b-btn v-if="mode == 'edit'"
				       type="submit"
				       variant="primary"
				       v-b-tooltip.hover
				       title="Opslaan"
				       class="pull-right"><i class="fa fa-fw fa-save"></i></b-btn>

				<b-btn v-if="mode == 'add'"
				       type="submit"
				       variant="primary"
				       v-b-tooltip.hover
				       title="Veiling aanmaken"
				       class="pull-right"><i class="fa fa-fw fa-save"></i></b-btn>
			</div>


		</b-form>

	</div>

</div>
</template>

<script>
import { isNil, pick, forOwn, keys } from 'lodash';
import AuctionService from '@/services/auction-service';
import PartialLoader from '@/components/elements/PartialLoader';
import { flashSuccess } from '@/helpers/flash-message-helper';
import { replaceEmptyByNull } from '@/helpers/object-helper';
import { formatDate } from '@/filters/date-filters';

export default {
	components: {
		PartialLoader
	},
	data() {
		return {
			isFetching: true,
			mode: 'add',
			auction: {},
			form: {
				title: '',
				abbreviation: '',
				description: '',
				start: '',
				end: '',
				seller_commission_percentage: '20.00',
				buyer_commission_percentage: '30.00',
				photo_cost: '5.00',
				table_money: '0.50',
				bill_remark_text: '',
				bill_footer_text: '',
				overview_remark_text: '',
				overview_footer_text: '',
				seller_invoice_email_text: '',
				buyer_invoice_email_text: ''
			},
			formError: false
		}
	},
	watch: {
		auction() {
			this.form = pick(this.auction, keys(this.form));
			this.form.start = formatDate(this.form.start, 'YYYY-MM-DD');
			this.form.end = formatDate(this.form.end, 'YYYY-MM-DD');
		},
	},
	methods: {
		fetchAuction(auctionId) {
			return AuctionService.getOne(auctionId)
				.then(response => {
					this.isFetching = false;
					this.auction = response;
				}).catch(error => {
					this.isFetching = false;
					this.error = error.message;
				});
		},
		submitForm(event) {
			this.isFetching = true;

			const post = replaceEmptyByNull(this.form);

			if (this.mode == 'add') {
				return AuctionService.create(post).then(response => {
					flashSuccess(this.$t('auction.createSuccess'), true);
					this.$router.push({ name: 'auctionList' });
				}).catch(error => {
					this.isFetching = false;
					this.formError = error.response.data;
				});
			} else {
				return AuctionService.update(this.$route.params.auctionId, post).then(response => {
					flashSuccess(this.$t('auction.updateSuccess'), true);
					this.$router.push({ name: 'auctionList' });
				}).catch(error => {
					this.isFetching = false;
					this.formError = error.response.data;
				});
			}
		}
	},
	mounted() {
		// check if item id exists otherwise add :)
		if (!isNil(this.$route.params.auctionId)) {
			this.mode = 'edit';
			this.fetchAuction(this.$route.params.auctionId);
		} else {
			this.isFetching = false;
		}
	}
}
</script>



// WEBPACK FOOTER //
// AuctionForm.vue?351edca8